import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);
import routes from "./routes";
import unit from "./../assets/js/common";
import store from "@/store";
let router = new Router({
  routes,
});
const UserGroup = (resolve) => require(["@/page/account/user"], resolve);
const accountAdd = (resolve) => require(["@/page/account/add"], resolve);
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
router.beforeEach((to, from, next) => {
  const isAdmin = localStorage.getItem("t") && store.state.user.id === 1;
  // 检查路由是否已存在（兼容旧版 Vue Router）
  const routeExists = router
    .getRoutes()
    .some((route) => route.name === "accountAdd");

  if (isAdmin && !routeExists) {
    const homeRoute = router.options.routes.find(
      (route) => route.path === "/home"
    );
    if (homeRoute) {
      // 动态添加管理员专属路由到 /home 的 children
      homeRoute.children.push(
        {
          path: "/account/add",
          component: accountAdd,
          name: "accountAdd",
          meta: {
            curs: "3-1",
            title: "基础管理,账户信息管理,新增账户",
          },
        },
        {
          path: "/account/edit",
          component: accountAdd,
          name: "accountEdit", // ⚠️ name 必须唯一
          meta: {
            curs: "3-1",
            title: "基础管理,账户信息管理,修改账户",
          },
        },
        {
          path: "/account/user",
          component: UserGroup,
          name: "userGroup",
          meta: {
            curs: "3-1",
            title: "基础管理,账户信息管理,用户组管理",
          },
        }
      );

      // 重新加载路由
      router.addRoutes([homeRoute]);
      next(to.fullPath); // 重新导航以应用新路由
      return;
    }
    next(to.fullPath); // 重新加载路由
    return;
  }
  if (!from.name && to.name) {
    //判断页面刷新
    // 执行刷新后的逻辑恢复水印
    if (store.state.user.uname) {
      store.dispatch("updateWatermarks"); // 调用 Vuex action 重新计算水印
    }
  }
  // 没有路由信息跳转到首页
  if (!to.name) {
    router.push({ name: "home" });
  } else {
    next();
  }
  next();
});
export default router;
